import { SEARCH_VEHICLE_RATE_LIMIT_EXCEEDED } from '@1po/1po-bff-fe-spec/generated/common/ResponseType';
import { SagaIterator } from 'redux-saga';
import { call, put, takeEvery } from 'redux-saga/effects';
import { resetVehicleSearchStatus } from 'domains/catalog/Catalog.store';
import { WsResponse } from 'domains/webSockets/WebSocket.types';
import { notifyTop } from 'UI/Notification/notification';
import { AppTranslation, sagaGuard } from 'utils';

export type SearchRateLimitType = 'SHORT_TERM' | 'LONG_TERM';

export type SearchRateLimitExceededPayload = {
  requestId: string;
  retryAfterSeconds: number;
  limitType?: SearchRateLimitType;
};

/** Toaster style is driven only by limitType — window duration is variable and must not classify. */
export function isLongTermRateLimitViolation(limitType: SearchRateLimitType | undefined): boolean {
  return limitType === 'LONG_TERM';
}

export function* handleSearchRateLimitViolationSaga(action: WsResponse<SearchRateLimitExceededPayload>): SagaIterator {
  const requestId = action.payload?.requestId;
  const retryAfterSeconds = action.payload?.retryAfterSeconds ?? 10;
  const isLongTermViolation = isLongTermRateLimitViolation(action.payload?.limitType);

  if (requestId) {
    yield put(resetVehicleSearchStatus({ requestId, query: '' }));
  }

  if (isLongTermViolation) {
    const hours = Math.max(1, Math.ceil(retryAfterSeconds / 3600));
    yield call(
      notifyTop,
      'error',
      AppTranslation.t('search.rate_limit.long_term_title', 'Search limit reached') as string,
      AppTranslation.t('search.rate_limit.long_term_message', 'Please try again in {{hours}} hour(s).', {
        hours,
      }) as string,
    );
  } else {
    yield call(
      notifyTop,
      'warning',
      AppTranslation.t('search.rate_limit.short_term_title', 'Search limit') as string,
      AppTranslation.t('search.rate_limit.short_term_message', 'Please try again in {{retryAfter}} second(s).', {
        retryAfter: retryAfterSeconds,
      }) as string,
    );
  }
}

export function* searchRateLimitErrorSaga(): SagaIterator {
  yield takeEvery(SEARCH_VEHICLE_RATE_LIMIT_EXCEEDED, sagaGuard(handleSearchRateLimitViolationSaga));
}
